"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.artifactType = 'userInputNeeded';
// Zod schema + new config type
exports.NodeConfigSchema = v4_1.z
    .object({
    inputType: finley_types_1.DbTable.UserInputTypeSchema.describe('Type of user input required'),
})
    .describe('Configuration for userInputNeeded node');
// Zod schema + new node type
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
})
    .extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    loanProductSlug: v4_1.z.string().nullable(),
    creditFacilitySlug: v4_1.z.string().nullable(),
    configuration: exports.NodeConfigSchema,
})
    .describe('Schema for userInputNeeded DB record');
//# sourceMappingURL=node.js.map